import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import HomeStub from "pages/home/HomeStub";

const HomeShellLayout = () => {
  return (
    <GlobalNavigationShell notificationsEnabled={false} navSlotPlacement="none">
      <HomeStub />
    </GlobalNavigationShell>
  );
};

export default HomeShellLayout;
